module.exports = __webpack_public_path__ + "img/768_stores_img2.2ef8b685.png";